import {useContext} from 'react';
import classNames from 'classnames';
import {observer} from "mobx-react";
import PropTypes from 'prop-types';
import {CSSTransition} from "react-transition-group";

import styles from './styles/Header.module.scss';

import NavigationPrimary from './NavigationPrimary';
import HeroContainer from './HeroContainer';
import NavigationSecondary from './NavigationSecondary';
import {StoreContext} from "../../stores/StoreLoader";

const mainHeaderClassName = classNames({
    [styles.mainHeader]: true,
});
const heroContainerClassName = classNames({
    [styles.heroContainer]: true,
});

const transitionClassNames = {
    enter: styles.transitionEnter,
    enterActive: styles.transitionEnterActive,
    enterDone: styles.transitionEnterDone,
    exit: styles.transitionExit,
    exitActive: styles.transitionExitActive,
    exitDone: styles.transitionExitDone,
};

const Header = observer((props) => {
    const {styleStore} = useContext(StoreContext);

    return (
        <>
            <ul className={styles.skip}>
                <li>
                    <a href={'#navigation'}>Skip to Navigation</a>
                </li>
            </ul>
            <NavigationPrimary
                isWelcomePage={props.isWelcomePage}
                heroIsEnabled={props.displayHero}
            />
            {props.displayHero &&
                <CSSTransition in={props.displayHero} classNames={transitionClassNames} timeout={250}>
                    <div className={heroContainerClassName}>
                        <HeroContainer
                            handleViewHomepage={props.handleViewHomepage}
                            displayViewHomepageButton={props.displayViewHomepageButton}
                            allowEditing={props.allowEditing}
                            isWelcomePage={props.isWelcomePage}
                        />
                    </div>
                </CSSTransition>}
            {/* Minimal Theme does not support vertical grids for now! */}
            {styleStore.themeID === "3" || <NavigationSecondary
                isWelcomePage={props.isWelcomePage}
            />}
        </>
    );
});

Header.propTypes = {
    displayHero: PropTypes.bool.isRequired, // displayHero is prop passed from config because not all pages have hero enabled
    displayViewHomepageButton: PropTypes.bool,
    displaySourcesWidget: PropTypes.bool,
    allowEditing: PropTypes.bool,
    currentFullUrl: PropTypes.string,
    isWelcomePage: PropTypes.bool,
    handleViewHomepage: PropTypes.func,
};

Header.defaultProps = {
    displayViewHomepageButton: false,
    displaySourcesWidget: false,
    allowEditing: false,
    isWelcomePage: false,
};

export default Header;
